var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gmp-page gmp-page--no-newsletter"},[_c('DS_two_column_fullbleed'),_c('DS_features_module_zero'),_c('DS_features_module_two'),_c('DS_features_module_three')],1)}
var staticRenderFns = []

export { render, staticRenderFns }